import RouteNames from '../../../../../../app/router/_internals/RouteNames.enum';

export default Object.freeze({
	GENERAL: `${RouteNames.AGENTS}-general`,
	SKILLS: `${RouteNames.AGENTS}-skills`,
	QUEUES: `${RouteNames.AGENTS}-queues`,
	PERMISSIONS: `${RouteNames.AGENTS}-permissions`,
	SUBORDINATES: `${RouteNames.AGENTS}-subordinates`,
	WFM: `${RouteNames.AGENTS}-wfm`,
	HISTORY: `${RouteNames.AGENTS}-history`,
});
